import capitalizeText from '@/utils/capitalize-text'
import event from '@/utils/event'
import { Inscription } from '@/utils/types/inscription'

const WARNING_ERRORS = [
	'MULTIPLE_INSCRIPTIONS_IN_OUTPOINT',
	'EXCESS_SATS_IN_INSCRIPTION_OUTPOINT'
]

export type ErrorDetail = {
	type: 'MULTIPLE_INSCRIPTIONS_IN_OUTPOINT' | 'EXCESS_SATS_IN_INSCRIPTION_OUTPOINT'
	inscriptions?: Inscription[]
	totalSats?: number
}

export default class ErrorHandler {
	public static errorDetail(error: any): ErrorDetail | null {
		const data = error?.response?.data

		if (WARNING_ERRORS.includes(data?.type)) {
			return { type: data?.type, inscriptions: data?.inscriptions, totalSats: data?.total_sats }
		}

		return null
	}
	public static snackbar(error: any) {
		if (error?.response) {
			const { response } = error
			const title = capitalizeText(response.data.message)
			event.emit('snackbar', { variant: 'error', title })
		}
	}
}
